import { FoldableSearch } from '@web/components/FoldableSearch/FoldableSearch';

type Props = {
  onSubmitSearch?: (query: { query: string }) => void;
  onValueChange?: (query: { query: string }) => void;
  onCancelSearch?: () => void;
  submitEager?: boolean;
  transparentBackground?: boolean;
  initialValue?: string;
};

export const FoldableSearchAngularWrapper = ({
  onSubmitSearch,
  onValueChange,
  ...props
}: Props) => {
  return (
    <FoldableSearch
      {...props}
      onSubmitSearch={(query: string) => onSubmitSearch?.({ query })}
      onValueChange={(query: string) => onValueChange?.({ query })}
    />
  );
};
